"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var server_1 = require("react-dom/server");
function createIcon(options) {
    var size = options.size ? options.size : 8;
    var icon;
    if (options.shape === "circle") {
        var radius = size / 2 - 0.75;
        icon = (react_1.default.createElement("circle", { cx: radius + 0.75, cy: radius + 0.75, r: radius, stroke: options.stroke, strokeWidth: "1.5", fill: options.fill, fillOpacity: options.opacity ? options.opacity : 1 }));
    }
    else {
        var widthAndHeight = size - 3;
        icon = (react_1.default.createElement("rect", { x: "1.5", y: "1.5", height: widthAndHeight, width: widthAndHeight, stroke: options.stroke, strokeWidth: "1.5", fill: options.fill, fillOpacity: options.opacity ? options.opacity : 1 }));
    }
    return options.asString ? (server_1.renderToString(icon)) : (react_1.default.createElement("svg", { height: size + "px", width: size + "px" }, icon));
}
exports.createIcon = createIcon;
